import {batch, signal} from "@preact/signals-react"
import {getPreviousDate} from "@ui-seeker/utils"

export const groupedExportsDateRange = signal([ getPreviousDate({ days: 0 }), getPreviousDate({ days: 0 }) ])
export const isLoadingTable = signal(true)
export const groupedExportsModalId = signal(null)

export const resetSignals = () => batch(() => {
	groupedExportsDateRange.value = [ getPreviousDate({ days: 0 }), getPreviousDate({ days: 0 }) ]
	isLoadingTable.value = true
	groupedExportsModalId.value = null
})